var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"},attrs:{"id":"UIdevelopmentproject"}},[_c('div',{attrs:{"id":"ad67f482"}},[_vm._v(" 开发中列表 ")]),_c('div',{attrs:{"id":"ddd46c1c"}},[_c('dal-comp-development',{attrs:{"id":"cmpddd46c1c"}})],1),_c('el-pagination',{attrs:{"id":"cc929b1b"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }